import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    productData: null,
    message: null,
}


export const createproductcatalog = createAsyncThunk("createproductcatalog", async (data) => {
    try {
        const response = await fetch(`/api/preExistingProducts`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error('Failed to create pre-existing product catalog');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to create pre-existing product catalog', error);
    }
});

const preExistingProductCatalog = createSlice({
    name: "preExistingProductCatalog",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(createproductcatalog.pending, (state) => {
            state.status = "Inprogress"
            state.productData = null;
            state.message = null
        });
        builder.addCase(createproductcatalog.fulfilled, (state, action) => {
            state.status = "SUCCESS"
            state.productData = action.payload.data;
            state.message = "Pre-Existing Product Completed"
        });
        builder.addCase(createproductcatalog.rejected, (state) => {
            state.status = "FAILED"
            state.productData = null;
            state.message = "pre-Existing Product failed"
        });
    }
})

export default preExistingProductCatalog.reducer